import React, { useContext } from 'react'
import { Menu as UikitMenu, MenuEntry} from '@pancakeswap-libs/uikit'
import { useWeb3React } from '@web3-react/core'
import { allLanguages } from 'constants/localisation/languageCodes'
import { LanguageContext } from 'hooks/LanguageContext'
import { useTranslation } from 'react-i18next'
import useTheme from 'hooks/useTheme'
// import useGetPriceData from 'hooks/useGetPriceData'
// import useGetLocalProfile from 'hooks/useGetLocalProfile'
import useAuth from 'hooks/useAuth'
import config from './config'

const Menu: React.FC = (props) => {
  const { account } = useWeb3React()
  const { login, logout } = useAuth()
  const { selectedLanguage, setSelectedLanguage } = useContext(LanguageContext)
  const { isDark, toggleTheme } = useTheme()
  const { t } = useTranslation()
  // const priceData = useGetPriceData()
  const priceData = null
  let cakePriceUsd = 0;
  try {
    cakePriceUsd = priceData ?  0 : 0
  } catch (e) {
    // Ignore
  }
  // const profile = useGetLocalProfile()
  // console.log(selectedLanguage.code, 'selectedLanguage----------------')
  let link: MenuEntry[] = config
  link = link.map(item => {
    return {
      label: t(item.label),
      icon: item.icon,
      href: item.href,
    }
  })
  return (
    <UikitMenu
      links={link}
      account={account as string}
      login={login}
      logout={logout}
      isDark={isDark}
      toggleTheme={toggleTheme}
      currentLang={selectedLanguage?.code || 'en'}
      langs={allLanguages}
      setLang={setSelectedLanguage}
      cakePriceUsd={cakePriceUsd}
      {...props}
    />
  )
}

export default Menu
